import apiClient from 'api/common/common'
import { SummaryDocumentValidationRequest } from 'api/common/requests'
import { SummaryDocumentValidationResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { AxiosResponse } from 'axios'
import { SummaryDocumentStatusType } from 'api/common/constants'

/**
 * 概要書面有効性チェックAPI
 * @param request
 * @param callback
 */
const summaryDocumentValidationAPI = async (request: SummaryDocumentValidationRequest, callback: (status: Status, result: SummaryDocumentStatusType[]) => void) => {
  await apiClient.post('/summaryDocument/validation', request).then((response: AxiosResponse<SummaryDocumentValidationResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    if (status === Status.Success) {
    }
    callback(status, response.data.result)
  })
}

export default summaryDocumentValidationAPI
